import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

/**
 * SCRUM-365: shown on the payment pages when the plans request (the source of
 * the payment currency) fails. Copies the PricingPage `PriceErrorBlock` markup, plus a retry, so
 * a failure is never a silently disabled Pay button.
 */
export function PricesRetryAlert({ onRetry, className }: { onRetry: () => void; className?: string }) {
  return (
    <div
      role="alert"
      className={cn(
        "rounded-2xl border border-amber-200 bg-amber-50 p-4 flex flex-wrap items-center gap-3",
        className,
      )}
    >
      <AlertTriangle className="w-5 h-5 text-amber-600 shrink-0" aria-hidden="true" />
      <p className="text-sm font-bold text-amber-900 flex-1 min-w-0">
        We couldn&apos;t load prices right now.
      </p>
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={onRetry}
        className="cursor-pointer border-amber-300 bg-white hover:bg-amber-100"
      >
        Try again
      </Button>
    </div>
  );
}
